import React from 'react';
const points = ['Estás cansada de dedicar tus noches a planificar por no tener un sistema profesional.', 'Llegas a casa agotada y todavía tienes que ponerte a escribir la sesión del día siguiente.', 'Sientes que siempre das los mismos ejercicios y tus alumnas han dejado de mejorar.', 'Necesitas demostrar resultados ante tus alumnas con fundamentos técnicos, no con palabras.'];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-117">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-118"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-119">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-12 text-center tracking-tight" data-id="element-120">
          Este sistema es para ti si...
        </h2>

        <div className="space-y-4" data-id="element-121">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt/80 backdrop-blur-sm rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-colors group shadow-lg" data-id="element-122">
              <div className="w-8 h-8 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 group-hover:bg-check-green group-hover:border-check-green transition-colors shadow-[0_0_10px_rgba(16,185,129,0.2)]" data-id="element-123">
                <span className="text-check-green group-hover:text-white text-sm font-bold transition-colors" data-id="element-124">
                  ✓
                </span>
              </div>
              <p className="text-text-main text-lg font-medium leading-relaxed" data-id="element-125">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}